import React from "react";
import { Box, Typography, TextField } from "@mui/material";
import { HISTORIC_DATA_UPDATE_ERRORS } from "../../../../pages/SHARED/Bond Creation Historic/components/historicCreationSharedPropTypes";

const HistoricOtherDetailsForm = ({ data, updateData, errors }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    updateData({ ...data, [name]: value });
  };

  return (
    <Box
      className="bg-gray-100 p-6 rounded-lg shadow-md max-w-3xl mx-auto mt-8"
      sx={{ border: "1px solid #e0e0e0" }}
    >
      <Typography variant="h5" className="font-bold mb-4">
        Other Details
      </Typography>

      <Box className="grid grid-cols-1 gap-4">
        <TextField
          label="Effective Date"
          name="effectiveDate"
          type="date"
          value={data.effectiveDate || ""}
          onChange={handleChange}
          fullWidth
          required
          error={!!errors.effectiveDate}
          helperText={errors.effectiveDate}
          slotProps={{ inputLabel: { shrink: true } }}
        />
      </Box>
    </Box>
  );
};

HistoricOtherDetailsForm.propTypes = HISTORIC_DATA_UPDATE_ERRORS;

export default HistoricOtherDetailsForm;
